import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Helmet } from 'react-helmet-async';
const BVHelmet = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Helmet><link rel="preconnect" href="https://apps.bazaarvoice.com" /><link rel="preconnect" href="https://display.ugc.bazaarvoice.com" /></Helmet>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default BVHelmet;